import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UploadImageComponent } from './upload-image/upload-image.component';
import { MaterialModule } from '../material.module';

@NgModule({
  declarations: [UploadImageComponent],
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  exports: [UploadImageComponent],
})
export class UploadImageModule {}
